// codegen: this was automatically generated
import styled, { css } from 'styled-components';
import { getBackgroundColor, getTextColor, getMediaQuery } from '@magalu/stereo-ui-styles';
import { typography } from 'styled-system';
import { Flex, Button, Text as TextElement } from '../../atoms';
export const Container = styled.a`
  display: flex;
  cursor: pointer;
  padding: 16px;
  border-radius: 12px;
  height: 100%;
  background-color: #fff;
  max-width: 560px;
  text-decoration: none;
  ${({
  showBorder
}) => showBorder && css`
      &,
      &:active,
      &:focus,
      &:hover {
        border: solid 1px ${getBackgroundColor('primary')};
      }
    `}
`;
export const ImageContainer = styled(Flex)`
  flex-direction: column;
  flex-basis: 30%;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  & > img {
    max-width: 100%;
    max-height: 100%;
  }
`;
export const Content = styled(Flex)`
  padding-left: 12px;
  flex-basis: 70%;
  flex-direction: column;
  justify-content: center;
`;
export const Title = styled(TextElement).attrs(props => Object.assign({
  fontSize: [1, 1, 1],
  lineHeight: 'big',
  fontWeight: 'regular'
}, props))`
  max-height: 44px;
  color: ${getTextColor('base')};
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  max-width: 97%;
  ${getMediaQuery('small')} {
    max-height: 44px;
  }
  ${typography}
`;
export const CardButton = styled(Button).attrs(props => Object.assign({}, props))`
  background-color: #4ea900;
  border-radius: 8px;
  margin-top: 12px;
  max-width: 264px;
  height: 40px;

  ${({
  empty
}) => empty && `
    pointer-events: none;
  `}
`;